import React from "react";
import { useMasterList } from "@/hooks/useMasterData";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const NONE = "__none__";

/** Single-select bound to a master-data list. */
export default function MasterSelect({ listType, value, onChange, placeholder = "Select…", allowNone = true, testId, filterLabels = null }) {
  const { data: opts = [] } = useMasterList(listType, {});
  const shown = filterLabels ? opts.filter((o) => filterLabels.includes(o.label)) : opts;
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger data-testid={testId || `select-${listType}`}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowNone && <SelectItem value={NONE}>{placeholder}</SelectItem>}
        {shown.map((o) => (
          <SelectItem key={o.id} value={o.id}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
